import type { Organization, Reference } from '@medplum/fhirtypes'
import type { ExtendedOrganization } from '@seen/core/models/organizations/ExtendedOrganization'
import { getReferenceString } from '@seen/core/references'
import { useMemo } from 'react'
import { useOrganizations } from '#src/hooks/useOrganizations.ts'

export function useOrganizationsFrom(
  refs: Reference<Organization>[]
): ExtendedOrganization[] {
  const organizationList = useOrganizations()

  return useMemo(() => {
    const relevantOrganizationsSet = new Set(refs.map(getReferenceString))

    return organizationList.filter((o) =>
      relevantOrganizationsSet.has(o.reference.reference)
    )
  }, [refs, organizationList])
}
